<template>
  <div>
    <Hero :title="title" :text="text"></Hero>
    <EmphasizeBox class="mt-2 mb-4" :text="`${$t('message.credit.disclaimer.noAffectScoreVersion2')}`"></EmphasizeBox>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Hero from '../../Hero.vue';
import EmphasizeBox from '../../EmphasizeBox.vue';

export default {
  name: 'LetUsKnow',
  components: {
    Hero,
    EmphasizeBox,
  },
  computed: {
    ...mapGetters('business', ['isPrequalificationEnabled', 'getDefaultCreditDataSourceCA']),
    title() {
      return this.getDefaultCreditDataSourceCA === this.enums.CreditDataSourceCA.CREDIT_PLUS
        ? this.$t('message.hero.letUsKnowTitleCreditPlus')
        : this.$t('message.hero.letUsKnowTitle');
    },
    text() {
      return this.isPrequalificationEnabled
        ? this.$t('message.hero.creditHeroMsgPrequal')
        : this.getDefaultCreditDataSourceCA === this.enums.CreditDataSourceCA.CREDIT_PLUS
        ? ''
        : this.$t('message.hero.creditHeroMsg');
    },
  },
};
</script>

<style scoped></style>
